module.exports = __webpack_public_path__ + "static/media/movie_trailer.502c4e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/movie_trailer.png
// module id = 41
// module chunks = 0